import { $_app_server } from '@/_helpers'

export const organizationService = {
    list,
    organization,
    orgtemplates,
    orgcategories,
    uploadFiles,
    request,
    gsuRequest,
    orgCreate,
    orgUpdate,
    orgDelete,
    templateCreate,
    templateUpdate,
    templateDelete,
    getTemplateURL,
    deliveryTypes
}

function list () {
    return $_app_server.get("organizations").then(response => response.data)
}

function orgcategories () {
    return $_app_server.get("orgcategories").then(response => response.data)
}

function organization (id) {
    return $_app_server.get("organizations/" + id).then(response => response.data)
}

function orgtemplates (id) {
    return $_app_server.get("orgtemplates/" + id).then(response => response.data)
}

function uploadFiles(formData) {
    return $_app_server.post('rfiles', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(response => response.data)
}

function request(obj) {
    return $_app_server.post("filerequest", obj).then(response => response.data)
}

function gsuRequest(obj) {
    return $_app_server.post("gsu/filerequest", obj).then(response => response.data)
}

function orgCreate( org ) {
    return $_app_server.post("organizations", org).then(response => response.data)
}

function orgUpdate( org ) {
    return $_app_server.put("organizations", org).then(response => response.data)
} 

function orgDelete (id) {
    return $_app_server.delete("organizations/"+id)
    .then(response => response.data)
}

function templateCreate( templ ) {
    return $_app_server.post("orgtemplates", templ).then(response => response.data)
}

function templateUpdate( templ ) {
    return $_app_server.put("orgtemplates", templ).then(response => response.data)
}
function templateDelete (id) {
    return $_app_server.delete("orgtemplates/"+id)
    .then(response => response.data)
}

function getTemplateURL (id) {
  return $_app_server.get('orgtemplates/url/' + id).then(response => response.data) 
}

function deliveryTypes () {
  return $_app_server.get('deliverytypes').then(response => response.data) 
}

